import React from 'react';
import Claws from './Claws';

/**
 * A section's arena light: drifting octagon grid, a breathing red (or gold)
 * glow and optional claw slashes. Sits behind the content; place inside a
 * `position: relative; isolation: isolate` section.
 */
export default function Backdrop({ glow = 'right', grid = true, claws = false, tone = 'red', className = '' }) {
  return (
    <div aria-hidden="true" className={`pnp-backdrop ${className}`.trim()}>
      {grid ? <div className="pnp-octagrid" /> : null}
      {glow !== 'none' ? <div className={`pnp-glow pnp-glow-${glow}${tone === 'gold' ? ' pnp-glow-gold' : ''}`} /> : null}
      {claws ? <Claws className="pnp-backdrop-claws" /> : null}
    </div>
  );
}
